<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size:15px; font-weight: bold">update bond details</small>
      </legend>
      <div>
        <form @submit.prevent="bondUpdate()">
          <div class="row">
            <input type="hidden" class="fileopening_id" :value="Bond.fileopening_id" />
            <input type="hidden" class="cargo_id" :value="Bond.cargo_id" />
            <input type="hidden" class="id" :value="Bond.id" />
            <div class="col-md-6">
              <div class="form-group">
                <label>Bond Amount</label>
                <input
                  type="number"
                  class="form-control bond_amount input-rounded f-s-14"
                  :value="Bond.bond_amount"
                  placeholder="bond amount"
                  required
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>T812 Entry</label>
                <input
                  type="number"
                  class="form-control t812_entry input-rounded f-s-14"
                  :value="Bond.t812_entry"
                  placeholder="t812 entry"
                  required
                />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat updatingBond btn-rounded">
            <i class="fa fa-plus"></i> update bond
          </button>
          <button type="button" class="btn btn-info btn-flat updatingBondLoader btn-rounded">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import $ from "jquery";
import router from "../router/index";
export default {
  created() {
    if (this.$store.getters.Bond.length === 0) {
      router.push("/managebonds");
    }
  },
  computed: {
    ...mapGetters(["Bond"])
  },
  methods: {
    ...mapActions(["bondUpdate"])
  }
};
</script>
<style scoped>
.updatingBondLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/bonds/updatebond.vue